/**
 * Created by trump on 2017/8/12.
 */
(() => {
    let APP_PUBLIC_PATH = window.APP_PUBLIC_PATH || top.APP_PUBLIC_PATH;
    
    if (APP_PUBLIC_PATH) {
        let publicPath = APP_PUBLIC_PATH;
    
    
        if (!/\/$/.test(publicPath)) {
            publicPath = publicPath + '/';
        }
        
        if (publicPath.indexOf('libs') < 0) {
            publicPath = publicPath + 'libs/';
        }
        
        __webpack_public_path__ = publicPath;
    }
})();



// WEBPACK FOOTER //
// ./_core/libRequirePathHelper.js